/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SqlVmNetworkInfo {
  /**
  * The Azure resource ID of the subnet where the VM is located
  */
  'subnetId': string;
  /**
  * The name of the virtual network containing the VM
  */
  'virtualNetworkName': string;
  /**
  * The name of the subnet where the VM is located
  */
  'subnetName': string;
  /**
  * The name of the resource group containing the subnet and virtual network
  */
  'resourceGroupName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "subnetId",
      "baseName": "subnetId",
      "type": "string",
      "format": ""
    },
    {
      "name": "virtualNetworkName",
      "baseName": "virtualNetworkName",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetName",
      "baseName": "subnetName",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SqlVmNetworkInfo.attributeTypeMap;
  }

  public constructor() {
  }
}

